import { Mixins, Component } from 'vue-property-decorator';
import { PaymentRequirementsItem } from '../../../api/incoming/payment-requirements-incoming.interface';
import { PaymentRequirementsStatusConfigMap, PaymentRequirementsStatusConfig, PaymentRequirementsStatusGetter } from '../interface';
import PaymentRequirementsStatusConfigs from './PaymentRequirementsStatusConfigs';

@Component
export default class PaymentRequirementsStatusMapper extends Mixins(
	PaymentRequirementsStatusConfigs
) {

	getPaymentRequirementsStatuses(
		paymentRequirementsItem: PaymentRequirementsItem
	): PaymentRequirementsStatusConfigMap {
		for (let index = 0; index < this.paymentRequirementsStatusGetters.length; index++) {
			const foundStatuses = this.paymentRequirementsStatusGetters[index](
				paymentRequirementsItem
			);

			if (foundStatuses) return foundStatuses;
		}

		return {};
	}

	getPaymentRequirementsStatusConfig(
		paymentRequirementsItem: PaymentRequirementsItem
	): PaymentRequirementsStatusConfig | null {
		const statuses = this.getPaymentRequirementsStatuses(paymentRequirementsItem);

		return (paymentRequirementsItem.status
			&& statuses[paymentRequirementsItem.status])
			|| null;
	}

	get paymentRequirementsStatusGetters(): PaymentRequirementsStatusGetter[] {
		return [
			(
				paymentRequirementsItem: PaymentRequirementsItem
			): PaymentRequirementsStatusConfigMap | undefined =>
				(paymentRequirementsItem.income
					&& this.paymentRequirementsIncomingStatusConfig)
				|| undefined,

			(
				paymentRequirementsItem: PaymentRequirementsItem
			): PaymentRequirementsStatusConfigMap | undefined =>
				(!paymentRequirementsItem.income
					&& this.paymentRequirementsOutgoingStatusConfig)
				|| undefined,
		];
	}

}